<script setup lang="ts"></script>

<template>
  <div class="text-center">Welcome to the Account-Service!</div>
</template>

<style scoped lang="scss"></style>
